module.exports = __webpack_public_path__ + "img/question-black.f2a16b7.svg";